import styled from '@emotion/styled';
import { SadaBtn } from '@components/k-btn/styles';
import { spacings } from '@constants/theme/spacing.config';

export const SadaKTimePicker = styled.div`
  ${SadaBtn.toString()} {
    margin: ${spacings.xxs} 0;
  }
`;
